export default __webpack_public_path__ + "static/MenuPositioning1_x2-2e5df53022c252a4aee3d90943bba946.png";